import React from "react";
import "./promptsCard.css";
import { condition } from "context/condition";
import { nanoid } from "nanoid";
import { createBotMessage, createUserMessage } from "utils/utils";
import { Globalstate } from "context/context";
import { useWebSocket } from "context/WebSocketProvider";
import useQna from "hooks/useQna";
import assetsMaanager from "assets/assetsmanager/assestsmanager";

const PromptsCard = ({ imgLink, text }) => {
  const userKey = nanoid();
  const botKey = nanoid();
  const userMessage = createUserMessage(text, "", userKey);
  const botMessage = createBotMessage("", botKey, "", [], [], "");

  const {
    dispatch,
    state: { isMessageSubmitted, mode, source, nudgeFlow }
  } = Globalstate();
  const { mutateAsync: mutateAsyncQna } = useQna();
  const { sendMessage } = useWebSocket();

  const handleClick = async () => {
    if (text === "") {
      return;
    }
    if (isMessageSubmitted) {
      return;
    }
    dispatch({ type: condition.ISMESSAGESUBMITTED, payload: true });

    dispatch({
      type: condition.SETMESSGES,
      payload: userMessage
    });
    dispatch({
      type: condition.SETMESSGES,
      payload: botMessage
    });
    if (mode === "qna" || nudgeFlow) {
      await mutateAsyncQna({
        searchTerm: text,
        botKey,
        source: source,
        nudgeFlow: nudgeFlow
      });
    } else {
      sendMessage({ query: text, botKey: botKey, source: source });
    }
    dispatch({ type: condition.ISMESSAGESUBMITTED, payload: false });
  };

  return (
    <div className="prompts-card" onClick={handleClick}>
      <div className="text-icon-container">
        <div className="prompts-card-icon">
          {imgLink ? (
            <img src={imgLink} alt="IMG" />
          ) : (
            <img className="rounded" src={assetsMaanager.chatIcon} alt="IMG" />
          )}
        </div>
        <div className="prompts-card-text">
          <p>{text}</p>
        </div>
      </div>

      <button className="prompts-card-button">
        <img src={assetsMaanager.redArrowRight} alt="" />
      </button>
    </div>
  );
};

export default PromptsCard;
